import { services } from '../services';
var action = "seller";

export const sellerService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    getOneByUser,
    suspend
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function getOneByUser(id) {
    return services.restApi(`sellerbyuser/${id}`, 'GET');
}

function suspend(object) {
    return services.restApi(`${action}/suspend`, 'POST', object);
}